<div class="py-2">
  <dx-select-box
    [items]="charts"
    [value]="current"
    stylingMode="underlined"
    displayExpr="title"
    (onValueChanged)="onValueChanged($event)"></dx-select-box>
</div>
<dx-chart
  id="time-pie-chart"
  palette="bright"
  [size]="{width: 320, height:250}"
  [dataSource]="report">
  <dxo-legend [visible]="false"></dxo-legend>
  <dxo-export [enabled]="true"></dxo-export>
  <dxo-title [text]="current.title">
    <dxo-font [size]="20" [weight]="300" color="black"></dxo-font>
  </dxo-title>

  <dxo-value-axis>
    <dxo-label [customizeText]="current.customizeText"></dxo-label>
  </dxo-value-axis>
  <dxi-series
    argumentField="name"
    type="bar"
    [valueField]="current.field">
    <dxo-label
      [visible]="true"
      position="columns"
      [customizeText]="current.customizeText">
      <dxo-font [size]="12"></dxo-font>
      <dxo-connector
        [visible]="true"
        [width]="0.5"></dxo-connector>
    </dxo-label>
  </dxi-series>
</dx-chart>
